import {
    codeToText,
    parsePlainIntegerCodeText,
} from "@common/helpers/accounting";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { getTypeCodeBlocks } from "@common/constants/domains/accounting/chartOfAccounts";

// First available (lowest unused) code in `type`'s block range(s): scans each
// block from its start, skipping any code already in `usedCodes`, and returns
// the first gap. Returns null when the type's code range can't be resolved or
// every code in range is taken (server validates either way).
export const firstAvailableCodeForType = ({
    type,
    usedCodes,
}: {
    type: AccountType;
    usedCodes: ReadonlySet<number>;
}): number | null => {
    const blocks = getTypeCodeBlocks(type);
    if (blocks.length === 0) {
        return null;
    }

    for (const block of blocks) {
        for (
            let candidate = block.startFrom;
            candidate <= block.upTo;
            candidate += 1
        ) {
            if (!usedCodes.has(candidate)) {
                return candidate;
            }
        }
    }

    return null;
};

export const allocateNextTemplateCodeText = ({
    type,
    accounts,
}: {
    type: AccountType;
    accounts: ReadonlyArray<{ codeText: string | null }>;
}): string | null => {
    const usedCodes = new Set<number>();
    for (const account of accounts) {
        const parsed = parsePlainIntegerCodeText(account.codeText);
        if (parsed != null) {
            usedCodes.add(parsed);
        }
    }
    return codeToText(firstAvailableCodeForType({ type, usedCodes }));
};
